export { Slider } from './Slider';